import React, { Component } from 'react';
import { Translate } from 'core/translate';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterPrimaryButton,
  ModalFooterCancelButton
} from '../common/modal/Modal';

class SpeedBump extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { cta, onClose } = this.props;
    window.open(cta.url, cta.openNewWindow ? '_blank' : '');
    onClose();
  }

  render() {
    const { onClose, cta, isFamilyFirstUS, isFamilyFirstCA } = this.props;
    return (
      <Modal isOpen={!!cta} onRequestClose={onClose}>
        <ModalHeader onClose={onClose} />
        <ModalBody>
          <div>
            {isFamilyFirstUS ? (
              <Translate value="model.selector.inventory.disclaimer" />
            ) : null}
            {isFamilyFirstCA ? (
              <Translate value="component.leave.app.warning" />
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalFooterButtons>
            <ModalFooterCancelButton onClick={onClose} />
            <ModalFooterPrimaryButton onClick={this.onClick} />
          </ModalFooterButtons>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SpeedBump;
